import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

enum ButtonColor {
  default = "default",
  secondary = "secondary",
}


export default /*#__PURE__*/_defineComponent({
  props: {
    color: null,
    small: { type: Boolean },
    fixedWidth: { type: Boolean },
    href: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.href ? 'a' : 'button'), {
    class: _normalizeClass(["py-2 px-6 md:py-3 md:px-8 text-white text-center rounded-full transform focus-visible:scale-110 hover:font-medium transition-transform outline-none inline-flex justify-center", {
      'bg-secondary': !__props.color || __props.color === ButtonColor.default,
      'border-white border-2': __props.color === ButtonColor.secondary,
      'text-sm md:text-base': !__props.small,
      'text-xs md:text-sm': __props.small,
      'w-52 md:w-64': __props.fixedWidth,
    }]),
    href: __props.href,
    target: (__props.href && '_blank') || ''
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "href", "target"]))
}
}

})